import Vue from 'vue';
import * as Sentry from '@sentry/vue';

!function() {
  window.Sentry = Sentry;

  // JSONハイジャック対策によりTrackerでは検出不能な形でエラーが吐かれるため，強制的にエラー形式を変換
  const parse = window.JSON.parse;
  window.JSON.parse = function() {
    try {
      // TODO rewrite for es6
      return parse.apply(this, arguments);
    } catch (e){
      throw Object.assign((new SyntaxError('JSON parse is failed.')), e);
    }
  };

  const debug = process.env.APP_ENV !== 'production';

  Sentry.init({
    dsn: process.env.SENTRY_JS_DSN,
    Vue: Vue,
    release: process.env.APP_ENV,
    environment: process.env.APP_URL.split('//').pop(),
    debug: debug,
    ignoreErrors: [
      'Non-Error promise rejection captured with keys: form_dc_c1.'
    ],
    integrations: integrations => {
      return integrations.filter(integration => integration.name !== 'Dedupe');
    },
    beforeSend(event, hint) {
      // stepEFのバリデーションエラーは報告しない
      if (hint.originalException && hint.originalException.from === 'store.actions.validate') {
        return null;
      }
      return event;
    },
  });

  // 開発環境ではすべてのトレース情報を出力する
  debug && Sentry.configureScope(function(scope) {
    scope.addEventProcessor(function(event, hint) {
      const message = (event.exception.values && event.exception.values[0] && event.exception.values[0].value) || 'undefined exception';
      console.error(message);
      console.log(event);
      console.log(hint);
      return event;
    });
  });
}();
